import React, { useEffect, useState } from 'react'
import { PaymentForm } from '@/components/quiz/paywall/PaymentForm'
import { PopupStatus } from '@/components/quiz/paywall/PopupStatus'
import { trackInitCheckout, trackPurchase } from '@/helpers/facebookPixelEvents'
import { useNavigate } from 'react-router-dom'
import { PaymentPlan } from '@/types/types'
import { PlanTotal } from '@/components/quiz/paywall/PlanTotal'
import { useQuizStore } from '@/store/useQuizStore'
import { checkUserSubscription } from '@/helpers/appHelpers'

export const Checkout = () => {
  const plan = JSON.parse(useQuizStore((s) => s.getAnswer('plan')) as string)
  const [successPaymentStatus, setSuccessPaymentStatus] = useState(false)
  const navigate = useNavigate()
  const [paywallLoading, setPaywallLoading] = useState(true)
  const email = localStorage.getItem('userEmail') ?? ''
  const [userHasSubscription, setUserHasSubscription] = useState(false)

  useEffect(() => {
    trackInitCheckout()
    checkUserSubscription(email ?? '').then((res) => {
      setUserHasSubscription(res.user && res.user.subscriptions.length > 0)
    })
  }, [])

  useEffect(() => {
    if (successPaymentStatus) {
      trackPurchase()
    }
  }, [successPaymentStatus])

  return (
    <>
      <PlanTotal plan={plan} />
      <PaymentForm
        plan={plan as PaymentPlan}
        email={email}
        onSuccess={setSuccessPaymentStatus}
        handleLoading={(val) => {
          if (paywallLoading) {
            setPaywallLoading(val)
            window.scrollTo(0, 0)
          }
        }}
      />
      {successPaymentStatus && (
        <PopupStatus
          icon="/img/success-icon.png"
          title="Your payment was successfull!"
          message="Thank you!"
          buttonTitle="Proceed To My Plan"
          onClick={() => {
            navigate('/quiz/thank-you', {
              state: { res: true },
            })
          }}
        />
      )}

      {userHasSubscription && (
        <PopupStatus
          icon="/img/success-icon.png"
          title="You already have subscription"
          buttonTitle="Proceed To Download"
          onClick={() => navigate('/quiz/thank-you')}
        />
      )}
      {paywallLoading && (
        <div className="fixed top-0 left-0 w-full h-full bg-bg z-10 pointer-events-auto opacity-100">
          <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
            <svg viewBox="0 0 100 100" height="76" className="animate-spin brightness-0 invert-0">
              <use href="/svg/sprite.svg#spinner"></use>
            </svg>
          </div>
        </div>
      )}
    </>
  )
}
